// Archivo generado automáticamente por scripts/generate-version.cjs
// No editar a mano.
export const BUILD_VERSION = '2.0.5';
export const BUILD_HASH = '77e3c0b';
